import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor() { }

  toasts: Subject<{}> = new Subject<{}>();

  show(header:string,textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.next({header, textOrTpl, ...options });
    //this.toasts.push({ textOrTpl, ...options });
  }

  showInfo(text:string) {
    this.show("Info",text, { classname: 'bg-primary text-light', delay: 5000 });
  }

  showSuccess(text:string) {
    this.show("Success",text, { classname: 'bg-success text-light', delay: 5000 });
  }

  showDanger(text:string) {
    this.show("Error",text, { classname: 'bg-danger text-light', delay: 7000 });
  }
}
